module.exports = __webpack_public_path__ + "img/s3-3.5dbb2d19.jpg";